import type { RouteObject } from 'react-router';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute';

const purchasesRoutes: RouteObject[] = [
  {
    path: 'PUR/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/PUR/PurchaseHome/PurchaseHome')) },

      { path: 'PurchaseReports', lazy: lazyRoute(() => import('../../pages/PUR/PurchaseReports/PurchaseReports')) },
      {
        path: 'PurchaseReports/:ReportId/ReportsBuilder',
        lazy: lazyRoute(
          () => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')
        )
      },

      {
        path: 'PurchaseDashboards',
        lazy: lazyRoute(() => import('../../pages/PUR/PurchaseDashboards/PurchaseDashboards'))
      },
      {
        path: 'PurchaseDashboards/:dashboardId/BuilderDashboard',
        lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard'))
      }
    ]
  },

  {
    path: 'PUR/*',
    children: [
      { path: 'SUPPLIERS', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Index')) },
      { path: 'SUPPLIERS/AddSupplier', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Add')) },
      {
        path: 'SUPPLIERS/:Id/UpdateSupplier',
        lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Update'))
      },
      {
        path: 'SUPPLIERS/:id/BranchesSupplier',
        lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Branches/Index'))
      }
    ]
  },

  {
    path: 'PUR/*',
    children: [
      // Quotation
      { path: 'Quotation', lazy: lazyRoute(() => import('../../pages/PUR/Transactions/Quotation/Index')) },
      {
        path: 'Quotation/AddPurchaseQuotation/:id?',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/Quotation/Add'))
      },
      {
        path: 'Quotation/:id/UpdatePurchaseQuotation',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/Quotation/Update'))
      },

      // Purchase Requests
      { path: 'PurchaseRequests', lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseRequest/Index')) },
      {
        path: 'PurchaseRequests/AddPurchaseRequest',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseRequest/Add'))
      },
      {
        path: 'PurchaseRequests/:id/UpdatePurchaseRequest',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseRequest/Update'))
      },

      // Purchase Order
      { path: 'PurchaseOrder', lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseOrder/Index')) },
      {
        path: 'PurchaseOrder/AddPurchaseOrder/:type?/:id?',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseOrder/AddPurchaseOrder'))
      },
      {
        path: 'PurchaseOrder/:id/UpdatePurchaseOrder/:type?',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseOrder/UpdatePurchaseOrder'))
      },

      // Purchase Bill
      { path: 'PurchaseBill', lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseBill/Index')) },
      {
        path: 'PurchaseBill/AddPurchaseBill',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseBill/Add'))
      },
      {
        path: 'PurchaseBill/:id/UpdatePurchaseBill',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/PurchaseBill/Update'))
      },

      // Purchase Return - From Purchase Order/ Purchase Bill
      {
        path: 'ReturnsPurchase-Order',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReturnsPurchase-Order/Index'))
      },
      {
        path: 'ReturnsPurchase-Order/:Id/AddUpdateViewPurchaseReturn',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReturnsPurchase-Order/PurchaseReturn'))
      },

      { path: 'ReturnsPurchase', lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReturnsPurchase/Index')) },
      {
        path: 'ReturnsPurchase/AddUpdateReturnsPurchase/:id?',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReturnsPurchase/Add'))
      },

      // {
      //   path: 'ReturnsPurchase/:Id/AddUpdateViewPurchaseReturn',
      //   lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReturnsPurchase/Update'))
      // },

      {
        path: 'ReceiveNoneInventoryItem',
        lazy: lazyRoute(() => import('../../pages/PUR/Transactions/ReceiveNoneInventoryItem/Index'))
      },

      // Accounting Period (prop)
      {
        path: 'AccountingPeriod',
        lazy: lazyRouteWithProps(
          () => import('../../pages/Finance/Settings/AccountingPeriod/Index'),
          () => ({ customProp: 'Pur' as const })
        )
      }
    ]
  }
];

export default purchasesRoutes;
